<template>
  <div style="display: inline-block">
  <el-popover
    v-if="!allowLiveOrderReview"
    style="margin-left: 10px;"
    v-permission="161"
    placement="bottom"
    width="180"
    v-model="visible">
    <div style="text-align: right; margin: 0">
      <el-button size="mini"
                 type="success"
                 @click="onekeyReview(true)">审核通过
      </el-button>
      <el-button size="mini"
                 type="danger"
                 @click="onekeyReview(false)">订单退回
      </el-button>
    </div>
    <el-button slot="reference"
               type="warning"
               size="mini">一键审核
    </el-button>
  </el-popover>

  <el-popover
    v-if="allowLiveOrderReview"
    style="margin-left: 10px;"
    placement="bottom"
    width="180"
    v-model="visible">
    <div style="text-align: right; margin: 0">
      <el-button size="mini"
                 type="success"
                 @click="onekeyReviewLive(true)">审核通过
      </el-button>
      <el-button size="mini"
                 type="danger"
                 @click="onekeyReviewLive(false)">订单退回
      </el-button>
    </div>
    <el-button slot="reference"
               type="warning"
               size="mini">一键审核
    </el-button>
  </el-popover>
  </div>
</template>

<script>
import QuestionReview from '@views/question-review/question-review.js'
import ReviewBox from '@views/question-review/components/ReviewBox/index'
import orderReviewValidate from '@views/order-review/mixins/order-review-validate.mixin.js'

export default {
  components: {},
  mixins: [orderReviewValidate],
  props: {
    salary: [Number, String],
    needGatherMarketPhoto: Boolean,
    errorMessages: Array,
  },
  data () {
    return {
      visible: false,
    }
  },
  computed: {
    ...Vuex.mapState({
      orderDetail: state => state.orderReview.orderDetail,
      // sjf 调整
      sjfOrderDetail: state => state.orderReview.sjfOrderDetail,
    }),
    ...Vuex.mapGetters('orderReview', [
      'allowLiveOrderReview',
    ])
  },
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    /**
     * 一键审核方法
     */
    onekeyReview (pass = true) {
      this.visible = false
      // 检查是否证据
      this.validateAnswer(['answer']).then(() => {
        setTimeout(() => {
          // 一键审核通过
          if (pass) {
            this.onekeyReviewPassed()
          } else {
            this.onekeyReviewNotPassed()
          }
        }, 200)
      })
    },
    /**
     * 一键审核通过
     */
    onekeyReviewPassed () {
      if (!this.checkSJFOrderValid()) {
        return
      }

      // 审核通过结算确认
      this.executeAnswerValidation()
    },
    executeAnswerValidation () {
      let validQuestions = QuestionReview().getValidQuestions()
      let marketPhotos = this.needGatherMarketPhoto ? QuestionReview().getAnswerMarketPhotos() : []
      ReviewBox.orderConfirm(
        (data) => {
          // 每一题审核通过
          validQuestions.forEach(({id}) => {
            QuestionReview().reviewPassed(id)
          })
          this.$emit('pass', data)
        }, this.salary, marketPhotos, this.orderDetail)
    },
    /**
     * 一键审核不通过
     */
    onekeyReviewNotPassed () {
      let validQuestions = QuestionReview().getValidQuestions()
      // 审核不通过结算确认
      ReviewBox.orderBack({
        callback: (data) => {
          // 每一题审核不通过
          validQuestions.forEach(({id}) => {
            QuestionReview().reviewNotPassed(id, data.message)
          })
          // 订单退回
          this.$emit('not-pass', data)
        },
        defaultProlongTime: this.orderDetail.endtime,
        messages: this.errorMessages,
      })
    },
    /**
     * 直播任务的一键审核
     */
    onekeyReviewLive (pass) {
      if (pass) {
        this.onReviewLiveFinish()
      } else {
        this.onReviewLiveClose()
      }
    },
    /**
     * 直播审核完成
     */
    onReviewLiveFinish () {
      ReviewBox.orderConfirm((data) => {
        this.$emit('pass', data)
      }, this.salary)
    },
    /**
     * 直播审核退回关闭
     */
    onReviewLiveClose () {
      ReviewBox.orderBack({
        callback: (data) => {
          // 订单退回
          this.$emit('not-pass', data)
        },
        messages: this.errorMessages,
        components: {prolongTime: false}
      })
    }
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/OnekeyReviewButton.vue